import React, { useEffect, useMemo } from 'react';
import { Routes, Route, useLocation, useSearchParams } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { useRef } from "react";
import { useTranslation } from 'react-i18next';

import {store} from './store'
import { Provider } from 'react-redux';

import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import global_es from './translations/es/global.json';
import global_en from './translations/en/global.json';

import { CssBaseline } from '@mui/material';

import {Header} from './components/navbar';
import {Header2} from './components/navbar';
import ScrollToTop from './components/util/ScrollToTop';
import {Screen} from './components/util';
import {Login} from './pages/login';
import {Signup} from './pages/signup';
import PasswordRecovery from './pages/passwordRecovery/PasswordRecovery';

import { Home } from './pages/home';
import { Aboutus } from './pages/aboutus';
import { FAQ } from './pages/faq';
import { GetInTouch } from './pages/getintouch'
import { Profile } from './pages/profile'
import ModalWaiting from './components/modal/ModalWaiting';
import {HomeAuth} from './pages/homeAuth';
import {Songs} from './pages/songs';
import LoadDataFromStorage from './components/util/LoadDataFromStorage';
import AuthenticatedRoute from './AuthenticatedRoute';
import NonAuthenticatedRoute from './NonAuthenticatedRoute';
import {SessionTimeoutHandler} from './components/util'
import { enqueueSnackbar } from 'notistack';
import { PasswordChange } from './pages/passwordChange';
import { ValidateProfile } from './components/util'
import AddAlbum from './pages/songs/addAlbum';
import ApprovalSongs from './pages/songs/approvalSongs';
import RolePermissionRoute from './RolePermissionRoute';
import TermsOfService from './pages/termsOfService/termsOfService';
import Users from './pages/userAdmin/users';
import Tos2 from './pages/termsOfService/tos2';
import ReviewsReport from './pages/reviewersReport/reviewsReport';
import ContactQuestions from './pages/contactQuestions/contactQuestions';
import ValidateFirstAccess from './components/util/ValidateFirstAccess';
import PreloadVideo from './pages/aboutus/preloadVideo';
import PrivacyPolicy from './pages/termsOfService/privacyPolicy';
import EndUserData from './pages/termsOfService/endUserData';
import Utilities from './components/util/utilities';
import VersionCheck from './components/util/VersionCheck';
import UsersView from './pages/userAdmin/usersview';
import AddAlbumFull from './pages/songs/addAlbumFull';


export default function RouterAppAnimation() {
    let location = useLocation();
    const nodeRef = useRef(null);   
    const shouldAnimate = useMemo(() => location.pathname, [location.pathname]);
    const [searchParams, setSearchParams] = useSearchParams();
    //TRANSLATION
    const [t, i18n] = useTranslation("global");


    return(
        <>
            <TransitionGroup>
                <CSSTransition in={true} key={shouldAnimate} classNames="fadeScreen" timeout={1000} nodeRef={nodeRef}>
                    <div ref={nodeRef}>
                        <Provider store={store}>
                            <I18nextProvider i18n={i18next}>
                                {/* {
                                    useVersionCheck()
                                } */}
                                <VersionCheck />
                                <CssBaseline />
                                <Screen />
                                <SessionTimeoutHandler />
                                <ScrollToTop />
                                <Header />
                                <Login />
                                <Utilities />
                                <PasswordRecovery />
                                <PasswordChange />
                                <Signup />
                                <ModalWaiting />
                                <ValidateProfile />
                                <ValidateFirstAccess />
                                <LoadDataFromStorage />
                                <Routes location={location}>
                                    <Route path='/termsofuse' element={<TermsOfService />} />
                                    <Route path='/privacypolicy' element={<PrivacyPolicy />} />
                                    <Route path='/enduserdata' element={<EndUserData />} />
                                    <Route element={<NonAuthenticatedRoute />}>
                                        <Route path='/' element={<Home />} />
                                        <Route path='/home' element={<Home />} />
                                        <Route path='/aboutus' element={<Aboutus />} />
                                        <Route path='/faq' element={<FAQ />} />
                                        <Route path='/getintouch' element={<GetInTouch />} />
                                        <Route path="*" element={<Home />} />
                                    </Route>
                                    <Route element={<AuthenticatedRoute />}>
                                        <Route path='/index' element={<HomeAuth />} />
                                        <Route path="*" element={<HomeAuth />} />
                                        <Route element={<RolePermissionRoute roles={["Artista"]} />}>
                                            <Route path="/songs" element={<Songs />} />
                                            <Route path="/profile" element={<Profile />} />
                                        </Route>
                                        <Route element={<RolePermissionRoute roles={["Artista", "Aprobador", "Administrador"]} />}>
                                            <Route path="/addalbum" element={<AddAlbumFull /> } />
                                        </Route>
                                        <Route element={<RolePermissionRoute roles={["Aprobador", "Administrador"]} />}>
                                            <Route path="/approvalsongs" element={<ApprovalSongs /> } />
                                            <Route path="/questions" element={<ContactQuestions /> } />
                                            <Route path="/userview" element={<UsersView /> } />
                                        </Route>
                                        <Route element={<RolePermissionRoute roles={["Administrador"]} />}>
                                            <Route path="/useradmin" element={<Users /> } />
                                            <Route path="/reviews" element={<ReviewsReport /> } />
                                        </Route>
                                    </Route>
                                </Routes>
                            </I18nextProvider>
                        </Provider>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </>
    )
}
